import { render } from "./PlanDeliverIframe.vue?vue&type=template&id=15143fa2&ts=true"
import script from "./PlanDeliverIframe.ts?vue&type=script&lang=ts&external"
export * from "./PlanDeliverIframe.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__